export interface Products {
  applications: Array<string>;
  axles: Array<string>;
  treads: Array<string>;
  dispositions: Array<string>;
  disposalCodes: Array<string>;
  makes: Array<string>;
  makeCodes: Array<string>;
  sizes: Array<string>;
  series: Array<string>;
  moldContours: Array<string>;
  treadBrands: Array<string>;
  allTreads: Array<string>;
  rollPartNumbers: Array<string>;
  finishedPartNumbers: Array<string>;
  widths: Array<string>;
  casingGrade: Array<string>;
}

export function emptyProducts(): Products {
  return {
    applications: [],
    axles: [],
    treads: [],
    disposalCodes: [],
    dispositions: [],
    makes: [],
    makeCodes: [],
    sizes: [],
    series: [],
    moldContours: [],
    treadBrands: [],
    allTreads: [],
    rollPartNumbers: [],
    finishedPartNumbers: [],
    widths: [],
    casingGrade: []
  };
}
